import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import StepMui from '@mui/material/Step';
import StepperMui from '@mui/material/Stepper';
import StepLabelMui from '@mui/material/StepLabel';

type ParamsStyle = {
    theme?: Theme;
}

export const Stepper = styled(StepperMui)(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    max-width: 100%;
    margin-left: -10px;
    align-items: center;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        margin-left: -23px;
        max-width: 27rem;
    }
`);

export const Step = styled(StepMui)(
    ({ theme }: ParamsStyle) => `
    width: 100%;

    .MuiStepConnector-root.MuiStepConnector-horizontal.MuiStepConnector-alternativeLabel {
        top: 24px;
        z-index: 1;
        left: calc(-50% + 1rem);
        right: calc(50% + 1rem);
    }

    .css-14qqfdt-MuiStepConnector-line {
        border-top-width: 2.5px;
    }

    &.Mui-completed {
        .MuiStepLabel-alternativeLabel {
            .MuiStepLabel-iconContainer {
                border: 2px solid #CBE49E;
            }
        }
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: 7.5rem;
    }
`);

export const StepLabel = styled(StepLabelMui)(
    ({ theme }: ParamsStyle) => `
    .MuiStepLabel-labelContainer {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .MuiStepLabel-alternativeLabel {
        color: ${theme?.palette.grey[400]};
        margin-top: 9px !important;
        font-weight: 600;
        z-index: 2;

        &.Mui-completed {
            color: ${theme?.palette.secondary.main};
        }

        &.MuiStepLabel-iconContainer {
            border: 2px solid ${theme?.palette.grey[400]};
            border-radius: 100px;
        }

        &.Mui-active {
            &.MuiStepLabel-label {
                margin-top: 0px !important;
                color: ${theme?.palette.primary.main};;
                padding: 0 3px;
                font-weight: 600;
                border-bottom: 2px solid ${theme?.palette.secondary.main};
            }
        }
    }

    .MuiSvgIcon-root {
        color: ${theme?.palette.grey[400]};
        width: 22px;
        height: 22px;

        text {
            fill: #fff;
        }

        &.Mui-active {
            color: #fff;
            width: 28px;
            height: 28px;
            border-radius: 100px;
            border: 1.6px solid #1C386B;

            .MuiStepIcon-text {
                fill: ${theme?.palette.primary.main};
                color: ${theme?.palette.primary.main};
            }
        }

        &.Mui-completed {
            fill: ${theme?.palette.secondary.main};
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 27px;
            height: 27px;
            
            &.Mui-active {
                width: 34px;
                height: 34px;
            }
        }
    }
               
    .MuiStepIcon-text {
        fill: ${theme?.palette.grey[400]};
        color: ${theme?.palette.grey[400]};
    }

    .css-zpcwqm-MuiStepConnector-root {
        .css-14qqfdt-MuiStepConnector-line {
            border-top-width: 5px;
        }
    }
`);

export const ContentShopping = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    justify-content: flex-end;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: 30%;
        max-width: 20.875rem;
        min-height: calc(100vh - 4rem);
        border-top: 1px solid rgba(141, 155, 181, 0.5);
    }
`);

export const LinkExtermal = styled('a')(`
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: .9375rem;
    
    svg {
        position: absolute;
        right: 1rem;
        height: 1.2rem;
    }
`);
